import CN_STUDENTS_MAP from '@/assets/data/cn/students.json';
import Config from '@/assets/data/config.json';
import EQUIPMENTS_MAP from '@/assets/data/equipments.json';
import StagesJSON from '@/assets/data/stages.json';
import { BAConfig, Equipment, Stage, Student } from '@/models/models';

const CNRegionConfig = (Config as BAConfig).Regions.find((region) => region.Name == 'Cn');

// 目前 Stage == A 的关卡意义不明，看上去国服没有，其他服务器有
// 比如：https://www.youtube.com/watch?v=N_j30vqm5J4
// 目前 https://schaledb.com/stage
// 理论上每个 No 都是 5 个普通关 + 3个困难关，中间穿插了 8 个 -A 管卡忽略不计
// 2025 年 8 月目前是 200 个关卡
export const STAGES = (Object.values(StagesJSON) as Stage[]).filter((stage) => {
  return stage.Category === 'Campaign' && stage.Stage != 'A' && stage.Area <= CNRegionConfig!.CampaignMax;
});

export const STUDENTS_BY_REALM = {
  CN: Object.values(CN_STUDENTS_MAP) as Student[],
};

const ALL_EQUIPMENTS = Object.values(EQUIPMENTS_MAP);

export const EQUIPMENTS_BY_REALM = {
  CN: ALL_EQUIPMENTS.filter((equipment) => equipment.IsReleased[2]) as Equipment[],
};

// 在一次遍历中计算 EQUIPMENT_CATEGORIES 和 EQUIPMENT_MAX_LEVELS_BY_REALM
const equipmentData = EQUIPMENTS_BY_REALM.CN.reduce(
  (acc, equip) => {
    if (equip.Tier > 1) {
      if (!acc.categories.has(equip.Category)) {
        acc.categories.add(equip.Category);
        acc.maxLevels[equip.Category] = equip.Tier;
      } else {
        acc.maxLevels[equip.Category] = Math.max(acc.maxLevels[equip.Category], equip.Tier);
      }
    }
    return acc;
  },
  {
    categories: new Set<string>(),
    maxLevels: {} as Record<string, number>,
  },
);

export const EQUIPMENT_CATEGORIES = Array.from(equipmentData.categories);

export const EQUIPMENT_MAX_LEVELS_BY_REALM = {
  zh: equipmentData.maxLevels,
};

const maxTier = Math.max(...Object.values(equipmentData.maxLevels));
export const TIERS = Array.from({ length: maxTier - 1 }, (_, i) => i + 2);

export const MAX_STAGE = CNRegionConfig!.CampaignMax;
